import React from 'react';

import { TableDataHeader } from '@block-explorer/ui';
import { TableRow, useMatchMedia } from '@make-software/cspr-ui';
import { Trans, useTranslation } from 'react-i18next';
import { useGetCasperNetwork } from '../../../services/casper-network-context.tsx';

export interface HomeDeploysListHeadersProps {}

const HomeDeploysListHeaders = (props: HomeDeploysListHeadersProps) => {
  const { t } = useTranslation();
  const { getLocalisationForNetworkVersion } = useGetCasperNetwork();
  const { common } = getLocalisationForNetworkVersion;

  const responsiveHashRowWidth = useMatchMedia(
    ['7.875', '13.75', '18.25', '10.75'],
    []
  );

  return (
    <TableRow>
      <TableDataHeader fixedWidthRem={Number(responsiveHashRowWidth)}>
        {t('{{hash}}', { hash: common.hash })}
      </TableDataHeader>
      <TableDataHeader fixedWidthRem={15.7}>
        <Trans t={t}>Action</Trans>
      </TableDataHeader>
      <TableDataHeader align={'right'}>
        <Trans t={t}>Amount</Trans>
      </TableDataHeader>
    </TableRow>
  );
};

export default HomeDeploysListHeaders;
